import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { EffectCoverflow, Navigation, Autoplay } from "swiper/modules";
import { CONSTANT } from "../../../constant/Constant";

export default function Events({ event }) {
  return (
    <div className="w-full h-auto flex justify-center items-center bg-white ">
      <div className="w-5/6 h-auto my-20 max-w-screen-2xl">
        <div className="w-full h-auto flex items-center  mt-10 ">
          {/* <div className='w-full h-auto  mt-10 grid lg:grid-cols-4 xl:gap-6 md:grid-cols-2 lg:gap-2 gap-20 bg-success '> */}
          <Swiper
            style={{
              "--swiper-navigation-color": "#7B899C",
            }}
            spaceBetween={20}
            loop={true}
            autoplay={{
              delay: 2000,
              disableOnInteraction: false,
            }}
            slidesPerView={1}
            breakpoints={{
              576: {
                slidesPerView: 2,
              },
              1000: {
                slidesPerView: 3,
              },
              1200: {
                slidesPerView: 5,
              },
            }}
            // onSlideChange={() => console.log("slide change")}
            // onSwiper={(swiper) => console.log(swiper)}
            effect={"coverflow"}
            grabCursor={true}
            centeredSlides={true}
            coverflowEffect={{
              rotate: 50,
              stretch: 1,
              depth: 100,
              modifier: 1,
              slideShadows: true,
            }}
            navigation
            modules={[EffectCoverflow, Navigation, Autoplay]}
            className="mySwiper"
          >
            {event.map((data) => (
              <SwiperSlide key={data._id}>
                <div>
                  <div className="border-2 border-primary  h-110 rounded-xl flex justify-center items-center shadow-lg hover:shadow-2xl">
                    <div className=" px-5 md:h-115 rounded-xl w-full mt-5 sm:mt-7 xl:mt-4">
                      <div className=" lg:h-80 h-80  flex justify-center items-center rounded-xl  md:h-70 w-full ">
                        <div className="w-full h-full rounded-xl relative ">
                          <img
                            className="object-cover h-full rounded-xl w-full"
                            src={`${CONSTANT.UI_URL}event/${data.eventThumb}`}
                            alt=""
                          />
                          {/* <div className="absolute w-19 h-7 bg-event top-4 right-3 rounded-2xl flex justify-center items-center font-satoshi text-sm text-white">
                            {data.location}
                          </div> */}
                        </div>
                      </div>
                      <div className="xl:w-60 xl:h-30 h-35 flex  justify-center items-center  lg:w-55 ">
                        <div className="w-full h-25 ">
                          <p className="text-2xl  font-medium font-satoshi lg:text-lg lg:font-bold">
                            {data.name}
                          </p>
                          <p className="mt-3  font-satoshi text-body line-clamp-2">
                            {data.description}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </div>
  );
}
